/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { http, HttpResponse } from 'msw'
import { translations, usercconsents, widthdrawalResponse } from './data'

export const consentWidgetHandlers = [
  http.get(
    'https://privacy.porsche-preview.com/static/consent-webcomponent/assets/i18n/de_DE_generic.json',
    getTranslationsForConsentWidgetResolver,
  ),
  http.get('https://api.ppc.porsche-preview.com/user/api/v2/de/de_DE/user-consent', getUserConsentResolver),
  http.get('https://api.ppc.porsche-preview.com/user/api/v2/de/de_DE/withdrawal-info', getWidthDrawalInfoResolver),
  http.post('https://api.ppc.porsche-preview.com/user/api/v2/de/de_DE/user-consent', postUserConsentResolver),
]

function getTranslationsForConsentWidgetResolver() {
  return HttpResponse.json(translations)
}

function getUserConsentResolver() {
  return HttpResponse.json(usercconsents)
}

function getWidthDrawalInfoResolver() {
  return HttpResponse.json(widthdrawalResponse)
}

function postUserConsentResolver() {
  return new HttpResponse(null, {
    status: 200,
  })
}
